import ApiService from "@/utils/api.service";

export default {

    create(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("service/" + params.serviceId + "/step", params.step)
                .then(({ data }) => {
                    //context.commit("setService", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    delete(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.delete("service/" + params.serviceId + "/step/" + params.stepId)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

}